/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {translate} from '@ion/core/src/locale/locale';

export interface NotificationMenuWrapperType {
  checkboxesEnabled: boolean;
  onMarkAllAsRead?: () => void;
  onSeeUnreadOnly?: () => void;
  onSelectMultiple?: () => void;
  onMarkSelectedAsRead?: () => void;
  onClearSelected?: () => void;
  onClearAll?: () => void;
  setCheckboxesEnabled?: () => void;
  children: JSX.Element;
  filterUnread?: boolean;
}

export interface NotificationMenu {
  menuItems: {
    title: string;
    handleClick: () => void;
    selected: boolean;
  }[];
}

export const NotificationMenu = ({
  checkboxesEnabled,
  onMarkAllAsRead,
  onSeeUnreadOnly,
  onSelectMultiple,
  onMarkSelectedAsRead,
  onClearSelected,
  setCheckboxesEnabled,
  onClearAll,
  children,
  filterUnread = false
}: NotificationMenuWrapperType) => {
  const menu: NotificationMenu = {
    menuItems : [
      {
        title       : translate('notifications:panel.menu.seeUnreadOnly'),
        handleClick : onSeeUnreadOnly,
        selected    : filterUnread
      },
      {
        title       : translate('notifications:panel.menu.clearAll'),
        handleClick : onClearAll,
        selected    : false
      }
    ]
  };

  return (
    <>
      {React.cloneElement(children, {
        menuItems : menu.menuItems
      })}
    </>
  );
};

export default NotificationMenu;
